document.addEventListener('DOMContentLoaded', function() {

  function injectKiwiChart() {
    let pollInterval;
    
    function injectChart(legendElement, fetchKiwiChart) {
      if (legendElement && fetchKiwiChart && !legendElement.contains(fetchKiwiChart)) {
        
        legendElement.appendChild(fetchKiwiChart);
        fetchKiwiChart.style.marginLeft = '15px';
        fetchKiwiChart.style.display = 'inline';
        //fetchKiwiChart.querySelector('._ks_text').style.fontSize = "15px";
        //console.log("Kiwi chart successfully injected!");
        clearInterval(pollInterval); 
      }
    }

    
    pollInterval = setInterval(function() {
      
      let productBlocks = document.querySelector(".globo-swatch-product-detail");

      if (productBlocks) {
        const fetchKiwiChart = document.querySelector('.ks-chart-modal-link.sizing-chart-modal-link.with-icon');
        const legendElement = document.querySelector('div.swatch--gl.clearfix > .name-option[data-name^="Taglia"]');
        //console.log("Globo fetchKiwiChart", fetchKiwiChart);
        //console.log("Globo legendElement", legendElement);
        injectChart(legendElement, fetchKiwiChart);
        fetchKiwiChart.style.marginLeft = '15px';
        fetchKiwiChart.style.display = 'inline';
        
      } else {
        
        //const fetchKiwiChart = document.querySelector('.ks-chart-modal-link.sizing-chart-modal-link.with-icon');
        //const legendElement = document.querySelector('.js.product-form__input.product-form__input--pill:last-of-type > legend.form__label');
        //console.log("Default fetchKiwiChart", fetchKiwiChart);
        //console.log("Default legendElement", legendElement);
        //injectChart(legendElement, fetchKiwiChart);
        //fetchKiwiChart.style.marginLeft = '15px';
        //fetchKiwiChart.style.display = 'inline';
        
      }
    }, 100);
  }

  injectKiwiChart();
  
});
